module.exports = __webpack_public_path__ + "static/user-list-interaction-do-0a1459c5be86a03d14c83f8f8f0c7c5a.png";